<template>
    <ul
        class="tree-view-list"
        tabindex="0"
        @keyup.up="up"
        @keyup.down="down"
        @keyup.enter="enter"
    >
        <TreeViewDirectory
            :model="directory"
            :active="activePath"
            :event-bus="eventBus"
            v-on-click-outside="deselectDirectory"
        />
    </ul>
</template>

<script>
    import Vue from 'vue';
    import { mixin as onClickOutside } from 'vue-on-click-outside';
    import TreeViewDirectory from './FileSystemTreeViewDirectory.vue';

    // TODO:
    // * arrow keys go up and down
    // * drag onto desktop

    export default {
        components: {
            TreeViewDirectory: TreeViewDirectory,
        },
        mixins: [
            onClickOutside
        ],
        props: {
            directory: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                activePath: null,
                eventBus: new Vue(),
            }
        },
        created() {
            // BUS 'SELECT' EVENT PASSED FROM CHILD (TreeViewDirectory)
            this.eventBus.$on('select-directory', (node) => { // selectNode?
                this.selectDirectory(node);
            });
        },
        beforeDestroy() {
            this.eventBus.$off('select-directory');
        },
        methods: {
            selectDirectory(node) {
                // OLD?: deselect triggers before hand, make sure this happens after - used to have setTimeout
                this.activePath = node.path; // pass it back down to tree list
                this.$emit('selected', node); // move up once deselect works?
            },
            deselectDirectory() {
                this.activePath = '';
            },
            up() {
                // this.activePath--;
            },
            down() {
                // this.activePath++;
                // this.deepSearch();
            },
            left() {

            },
            right() {
                // console.log('enter');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tree-view-list {
        list-style: none;
        padding: rem-calc(15 0 15 15);
        margin-top: -12px; // since the component uses position relative to shift down
    }
</style>